export function createNamespace(namespace: string) {
	return (name?: string) => name ? `${namespace}-${name}` : namespace;
}
